import { render, staticRenderFns } from "./EnvPreventRecommendView.vue?vue&type=template&id=e37b5ba6&scoped=true&"
import script from "./EnvPreventRecommendView.vue?vue&type=script&lang=js&"
export * from "./EnvPreventRecommendView.vue?vue&type=script&lang=js&"
import style0 from "./EnvPreventRecommendView.vue?vue&type=style&index=0&id=e37b5ba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e37b5ba6",
  null
  
)

export default component.exports